import { BaseService, BaseServiceConstructor } from 'api/services/base.service';
import { PublicMapData, MapSelectedPointData } from 'types/models/public/PublicMapData';
import router from 'next/router';
import qs from 'qs';
import { MapDisclaimer, MapOptions, H3Index } from 'types/models/map';
import { H3MetricsResponse } from 'types/responses/H3MetricsResponse';

export class MapService extends BaseService {
  constructor({ serviceUrls, token, tenantName }: BaseServiceConstructor) {
    super({ serviceUrls, token, tenantName });
  }

  async getPublicMapData(): Promise<PublicMapData[]> {
    const { data } = await this.httpClient.get<PublicMapData[]>(`/Public/MapData`, {
      headers: {
        'Tenant-Name': router.query.tenantName,
        'Content-Type': 'application/json',
      },
    });
    return data;
  }

  async getPropertyAddressSearchResults(searchQuery: string): Promise<MapSelectedPointData[]> {
    const { data } = await this.httpClient.get<MapSelectedPointData[]>(
      `/Public/PropertyAddressSearch?searchQuery=${encodeURIComponent(searchQuery)}`,
      {
        headers: {
          'Tenant-Name': router.query.tenantName,
          'Content-Type': 'application/json',
        },
      }
    );
    return data;
  }

  async getPublicMapOptions(): Promise<MapOptions> {
    const { data } = await this.httpClient.get<MapOptions>(`/Public/MapOptions`, {
      headers: {
        'Tenant-Name': router.query.tenantName,
      },
    });
    return data;
  }

  async getPublicMapDisclaimer(): Promise<MapDisclaimer> {
    const { data } = await this.httpClient.get<MapDisclaimer>(`/Public/MapDisclaimer`, {
      headers: {
        'Tenant-Name': router.query.tenantName,
        'Content-Type': 'application/json',
      },
    });
    return data;
  }

  async getH3Metrics(
    resolution?: number,
    fld?: string[],
    metrics?: string[],
    quantiles?: number
  ): Promise<H3MetricsResponse> {
    const queryString = qs.stringify(
      {
        resolution: resolution,
        group: fld,
        quantiles: quantiles,
        metrics: metrics,
      },
      {
        arrayFormat: 'brackets',
        encodeValuesOnly: true,
      }
    );

    const { data } = await this.publicHttpClient.get<H3MetricsResponse>(`/h3stats?${queryString}`, {
      withCredentials: false,
    });

    return data;
  }
}
